window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.section-kv').length === 0) {
    document.querySelector('#header').classList.add('--force-opaque');
  }
  document.querySelectorAll('.section-kv').forEach(section => {
    const $kvImg = section.querySelector('.__kv-img');
    ScrollTrigger.create({
      trigger: section,
      start: 'top top',
      end: 'bottom top',
      onUpdate: (self) => {
        const progress = self.progress;
        gsap.set($kvImg, {yPercent: progress * 70});
      }
    })
  });
})